import fetchTimesheets from '../Services/fetchTimesheets'

export default () => (dispatch) => {

  dispatch(fetchTimesheets())

}
